import Collection from '../collection';
import TaskState from '../model/task.state';





export default Collection.extend( {
	endpoint: 'tasks/states?apiVersion=2.0',
	responseAt: 'items',
    model: TaskState,
} );


// WEBPACK FOOTER //
// ./src/js/collection/task.states.js